import { render, staticRenderFns } from "./RcpyD_Details.vue?vue&type=template&id=53290119"
import script from "./RcpyD_Details.vue?vue&type=script&lang=js"
export * from "./RcpyD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports